import styles from './Corporate.module.css';

export default function Corporate() {
  return (
    <div>
        <h1>Corporate Work</h1>
        <div>
        <span>↓ Resume: </span>
            <a href="/assets/resume/RESUME.pdf" download="Volt's Resume (PDF).pdf" className={ styles.corporateATagSummary }> PDF</a>
            <span> | </span>
            <a href="/assets/resume/RESUME.docx" download="Volt's Resume (DOCX).docx" className={ styles.corporateATagSummary }>  DOCX  </a>
        </div>

        <div className={ styles.corporateHeaderSpacer }>
            <h4>Whitecloak Technologies Inc (Unionbank PH): Oct 2021 - Present</h4>
            <h5>> Team Captain - Mobile team (June 2022 - Present)</h5>
            <ul>
                <li>Introduce and implement MR procedure using GitLab for both Android and iOS</li>
                <li>RND of Unit testing for iOS and revision of iOS documentation</li>
                <li>Implementation of Method of Process for mobile deployment</li>
            </ul>

            <h5>> Journeyman SE / Mobile Developer (Jan 2022 - June 2022)</h5>
            <ul>
                <li>Manage and facilitate scrum ceremonies</li>
                <li>Discussions with core and tech leads to provide an efficient solution</li>
                <li>Releases deployment and support</li>
                <li>Assist the client’s other project it’s tech lead and its development team</li>
                <li>Implementation of a new feature for the project</li>
            </ul>

            <h5>> Middle SE / Mobile Developer (Oct 2021 - Dec 2021)</h5>
            <ul>
                <li>Created, developed, and maintained a full stack in-house app to cater to a client’s need using Swift</li>
                <li>Coordinated design based on client’s proposal with the use of Sketch</li>
                <li>Communicated with client and provide tutorial/presentation during meeting</li>
            </ul>
        </div>

        <div className="popup-divider"></div>

        <div>
            <h4>MobileMINDS Inc: August 2018 - Oct 2021</h4>
            <h5>> Team Captain - Mobile team (June 2022 - Present)</h5>
            <ul>
                <li>Introduce and implement MR procedure using GitLab for both Android and iOS</li>
                <li>RND of Unit testing for iOS and revision of iOS documentation</li>
                <li>Implementation of Method of Process for mobile deployment</li>
            </ul>

            <h5>> Journeyman SE / Mobile Developer (Jan 2022 - June 2022)</h5>
            <ul>
                <li>Manage and facilitate scrum ceremonies</li>
                <li>Discussions with core and tech leads to provide an efficient solution</li>
                <li>Releases deployment and support</li>
                <li>Assist the client’s other project it’s tech lead and its development team</li>
                <li>Implementation of a new feature for the project</li>
            </ul>

            <h5>> Middle SE / Mobile Developer (Oct 2021 - Dec 2021)</h5>
            <ul>
                <li>Created, developed, and maintained a full stack in-house app to cater to a client’s need using Swift</li>
                <li>Coordinated design based on client’s proposal with the use of Sketch</li>
                <li>Communicated with client and provide tutorial/presentation during meeting</li>
            </ul>
        </div>

        <div className="popup-divider"></div>
        
        <div className={ styles.corporateContainer }>
            <a href="./assets/resume/RESUME.docx" download="Volt's Resume (docx).docx" className={ styles.corporateATag }>
                <div className="my-3 mx-auto">
                    <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.corporateIcon }/>
                    <span className={ styles.corporateLabel + " mx-3"} >Resume (.docx)</span>
                </div>
            </a>
            
            <a href="./assets/resume/RESUME.pdf" download="Volt's Resume (PDF).pdf" className={ styles.corporateATag }>
                <div className="my-3 mx-auto">
                    <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.corporateIcon }/>
                    <span className={ styles.corporateLabel + " mx-3"} >Resume (PDF)</span>
                </div>
            </a>
        </div>
    </div>
  );
}
